import {AfterViewInit, Component, inject} from '@angular/core';
import {WelcomeVideoService} from '../../../../services/welcome-video.service';

@Component({
  selector: 'app-home-galery',
  imports: [],
  templateUrl: './home-galery.component.html'
})
export class HomeGaleryComponent implements AfterViewInit {

  welcomeVideoService = inject(WelcomeVideoService)

  ngAfterViewInit() {
    this.welcomeVideoService.loadVideo()
  }


}
